module.exports = __webpack_public_path__ + "static/media/tankerTrailer.e9dffe86.svg";